/*
  Envío gratis automático para difusores (promo DIFUSOR15, hasta el viernes 2-oct).

  Shopify no deja que un código de producto (DIFUSOR15, 15% en difusores) traiga
  envío gratis, y un código de envío gratis no se puede limitar a ciertos productos.
  El equipo creó DIFUSORENVIO (envío gratis, combinable con descuentos de producto),
  pero el cliente tendría que escribirlo. Esto lo aplica solo cuando hay un difusor
  en el carro y lo saca cuando ya no hay, o cuando termina la promo.

  Cómo: POST /cart/update.js { discount: 'A,B' } fija la lista completa de códigos del
  carro, por eso siempre mandamos los que ya tenía más o menos el nuestro. El código
  viaja al checkout, donde combina con DIFUSOR15 si el cliente también lo pone.

  Límite conocido: "Comprar ahora" en la ficha salta el carro y no pasa por aquí.

  Configuración: snippets/spot-envio-difusor.liquid (window.SpotEnvioDifusorConfig).
*/
(function () {
  var config = window.SpotEnvioDifusorConfig || {};
  var CODE = String(config.code || '').trim().toUpperCase();
  var IDS = config.productIds || [];
  var ENDS = Date.parse(config.endsAt || '');

  if (!CODE || !IDS.length) { return; }

  var busy = false;

  function getCart() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function setCodes(codes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    });
  }

  function refreshUI() {
    if (typeof window.refreshCartContents === 'function') {
      return window.refreshCartContents({ ok: true });
    }
    return null;
  }

  function reconcile() {
    if (busy) { return Promise.resolve(); }
    busy = true;

    return getCart().then(function (cart) {
      var codes = (cart.discount_codes || []).map(function (d) { return String(d.code || '').trim(); });
      var others = codes.filter(function (c) { return c.toUpperCase() !== CODE; });
      var has = others.length !== codes.length;
      var hasDifusor = (cart.items || []).some(function (item) { return IDS.indexOf(item.product_id) !== -1; });
      var active = !ENDS || Date.now() <= ENDS;
      var want = hasDifusor && active;

      if (want && !has) { return setCodes(others.concat(CODE)).then(refreshUI); }
      if (!want && has) { return setCodes(others).then(refreshUI); }
      return null;
    }).catch(function () {
      /* silent: el envío gratis nunca puede romper el carro */
    }).then(function () {
      busy = false;
    });
  }

  window.spotEnvioDifusorReconcile = reconcile; // usado por la verificación
  window.addEventListener('updated.ecomify.cart', reconcile);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
